$(document).ready(function() {
	const form = document.querySelector('[data-job-offer-form]');

	if (!form) {
		return;
	}

	const submitButton = form.querySelector('[type="submit"]');
	const module = form.closest('.module-jobofferform');
	const status = module?.querySelector('[data-job-offer-form-status]');
	const errorSummary = module?.querySelector('[data-job-offer-form-errors]');
	const successMessage = form.dataset.successMessage || 'Votre offre a ete envoyee.';
	let toastTimer = null;

	form.noValidate = true;

	form.querySelectorAll('[data-frm-editor="tinymce"][required], .frm-select2[required]').forEach((field) => {
		field.dataset.frmRequired = 'true';
		field.required = false;
	});

	const clearMessages = () => {
		if (status) {
			status.textContent = '';
			status.innerHTML = '';
			status.hidden = true;
		}

		if (errorSummary) {
			errorSummary.innerHTML = '';
			errorSummary.hidden = true;
		}

		form.querySelectorAll('[data-job-offer-field-error]').forEach((error) => {
			error.closest('.frm-field')?.classList.remove('frm-field--error');
			error.remove();
		});

		form.querySelectorAll('[aria-invalid="true"]').forEach((field) => {
			const describedBy = (field.getAttribute('aria-describedby') || '')
				.split(/\s+/)
				.filter((id) => id && !id.endsWith('-server-error'));

			field.removeAttribute('aria-invalid');
			if (describedBy.length) {
				field.setAttribute('aria-describedby', describedBy.join(' '));
			} else {
				field.removeAttribute('aria-describedby');
			}
		});
	};

	const showToast = (message) => {
		if (!module) {
			return;
		}

		let toast = module.querySelector('[data-job-offer-form-toast]');

		if (!toast) {
			toast = document.createElement('div');
			toast.className = 'module-jobofferform__toast';
			toast.dataset.jobOfferFormToast = 'true';
			toast.setAttribute('role', 'status');
			toast.setAttribute('aria-live', 'polite');
			module.appendChild(toast);
		}

		toast.textContent = message;
		toast.hidden = false;
		toast.classList.add('is-visible');

		window.clearTimeout(toastTimer);
		toastTimer = window.setTimeout(() => {
			toast.classList.remove('is-visible');
		}, 4500);
	};

	const setStatus = (message, type, previewUrl = null) => {
		if (!status) {
			return;
		}

		status.textContent = message;

		if (previewUrl) {
			const link = document.createElement('a');
			link.href = previewUrl;
			link.textContent = 'Voir la previsualisation';
			link.target = '_blank';
			link.rel = 'noopener noreferrer';
			status.appendChild(document.createTextNode(' '));
			status.appendChild(link);
		}

		status.hidden = false;
		status.dataset.state = type;
	};

	const scrollToNotification = () => {
		const target = status && !status.hidden ? status : errorSummary;

		if (!target) {
			return;
		}

		const top = target.getBoundingClientRect().top + window.scrollY - 120;
		window.scrollTo({
			top: Math.max(top, 0),
			behavior: 'smooth'
		});
		target.focus?.({ preventScroll: true });
	};

	const normalizeField = (field) => {
		if (field instanceof RadioNodeList) {
			return field[0] || null;
		}

		return field;
	};

	const getRequiredFieldValue = (field) => {
		if (field.matches('select[multiple]')) {
			return Array.from(field.selectedOptions).map((option) => option.value).join('');
		}

		if (field.dataset.frmEditor === 'tinymce') {
			return field.value
				.replace(/<[^>]*>/g, '')
				.replace(/&nbsp;/g, ' ')
				.trim();
		}

		if (field.type === 'checkbox' || field.type === 'radio') {
			return form.querySelectorAll(`[name="${field.name}"]:checked`).length ? 'checked' : '';
		}

		return String(field.value || '').trim();
	};

	const focusField = (field) => {
		const editor = field.dataset.frmEditor === 'tinymce' && window.tinymce ? window.tinymce.get(field.id) : null;

		if (editor) {
			editor.focus();
			return;
		}

		if ($(field).data('select2')) {
			$(field).select2('open');
			return;
		}

		field.focus?.();
	};

	const scrollToField = (field) => {
		const target = field.closest('.frm-field') || field;
		const top = target.getBoundingClientRect().top + window.scrollY - 120;

		window.scrollTo({
			top: Math.max(top, 0),
			behavior: 'smooth'
		});
	};

	const addFieldError = (name, messages) => {
		const field = normalizeField(form.elements[name] || form.elements[`${name}[]`]);

		if (!field) {
			return;
		}

		const id = field.id || name;
		const error = document.createElement('p');
		error.className = 'frm-field__error';
		error.id = `${id}-server-error`;
		error.dataset.jobOfferFieldError = 'true';
		error.textContent = messages.join(' ');

		field.setAttribute('aria-invalid', 'true');
		const fieldWrapper = field.closest('.frm-field');
		const describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);

		if (!describedBy.includes(error.id)) {
			describedBy.push(error.id);
			field.setAttribute('aria-describedby', describedBy.join(' '));
		}

		fieldWrapper?.classList.add('frm-field--error');
		(fieldWrapper?.querySelector('.frm-field__body') || fieldWrapper)?.appendChild(error);
	};

	const validateRequiredFields = () => {
		const invalidFields = Array.from(form.querySelectorAll('[required], [data-frm-required="true"]')).filter((field) => !getRequiredFieldValue(field));

		invalidFields.forEach((field) => {
			addFieldError(field.name, ['Merci de remplir ce champ avec les bonnes informations.']);
		});

		if (invalidFields.length) {
			showToast('Veuillez remplir tous les champs obligatoires.');
			scrollToField(invalidFields[0]);
			focusField(invalidFields[0]);
			return false;
		}

		return true;
	};

	const shouldSkipNativeValidation = (field) => {
		return field.dataset.frmEditor === 'tinymce' || $(field).data('select2');
	};

	const validateNativeFields = () => {
		const invalidField = Array.from(form.elements).find((field) => {
			return field.willValidate && !shouldSkipNativeValidation(field) && !field.checkValidity();
		});

		if (!invalidField) {
			return true;
		}

		showToast('Veuillez corriger le champ indique.');
		invalidField.reportValidity();
		return false;
	};

	const renderErrors = (errors) => {
		const items = [];

		Object.entries(errors || {}).forEach(([name, messages]) => {
			const list = Array.isArray(messages) ? messages : [String(messages)];
			addFieldError(name, list);
			items.push(...list);
		});

		if (errorSummary && items.length) {
			const list = document.createElement('ul');

			items.forEach((message) => {
				const item = document.createElement('li');
				item.textContent = message;
				list.appendChild(item);
			});

			errorSummary.appendChild(list);
			errorSummary.hidden = false;
		}
	};

	const syncEditors = () => {
		if (window.tinymce) {
			window.tinymce.triggerSave();
		}
	};

	const normalizeApplicationValue = (formData) => {
		const value = String(formData.get('candidateUrl') || '').trim();

		if (value && value.includes('@') && !value.includes('://') && !value.startsWith('mailto:')) {
			formData.set('candidateUrl', `mailto:${value}`);
		}
	};

	form.addEventListener('submit', async (event) => {
		event.preventDefault();
		clearMessages();
		syncEditors();

		if (!validateRequiredFields()) {
			return;
		}

		if (!validateNativeFields()) {
			return;
		}

		const originalButtonText = submitButton?.textContent;

		if (submitButton) {
			submitButton.disabled = true;
			submitButton.textContent = 'Envoi en cours...';
		}

		try {
			const formData = new FormData(form);
			normalizeApplicationValue(formData);

			const response = await fetch(form.action, {
				method: 'POST',
				body: formData,
				headers: {
					Accept: 'application/json'
				}
			});
			const data = await response.json();

			if (!response.ok || !data.success) {
				renderErrors(data.errors || {});
				setStatus('Veuillez corriger les champs indiques.', 'error');
				scrollToNotification();
				return;
			}

			form.reset();
			$(form).find('.frm-select2').val(null).trigger('change');
			setStatus(successMessage, 'success', data.previewUrl || null);
			scrollToNotification();
		} catch (error) {
			setStatus('Une erreur est survenue. Veuillez reessayer plus tard.', 'error');
			scrollToNotification();
		} finally {
			if (submitButton) {
				submitButton.disabled = false;
				submitButton.textContent = originalButtonText;
			}
		}
	});
});
